import classNames from 'classnames';
import styles from './ArticleMedia.module.scss';
import { Picture } from 'ui/components/1-atoms/Media/Picture/Picture';

export interface ArticleMediaProps {
	className?: string;
	image: {
		url: string;
		altText: string;
		focalPoint?: { left: number; top: number };
		fileType?: string;
	};
	caption: string;
}

export const ArticleMedia: React.FC<ArticleMediaProps> = ({ className, image, caption }) => (
	<figure className={classNames(styles.ArticleMedia, className)}>
		{image && (
			<span className={styles.ArticleMedia_mediabox}>
				<Picture
					aspectRatio={0.4}
					focalPoint={image.focalPoint}
					url={image.url}
					altText={image.altText}
					sizes="(max-width: 1728px) 100vw, 1728px"
					imageCropping="cover"
					className={styles.ArticleMedia_mediabox}
					fileType={image.fileType}
				/>
			</span>
		)}
		<figcaption className={styles.ArticleMedia_caption}>{caption}</figcaption>
	</figure>
);
